module.exports = __webpack_public_path__ + "img/works_ibk_btm_off.1e389cb8.png";